import React, {useContext} from 'react';
import {Button, Space, Table, theme} from 'antd';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import AccessUtil from "../../../components/util/access.util";
import {AgencyViewHistoryResponse} from "../../../types/modules/agency/response";
import {ViewCardStyled} from "../../../components/styled/card.styled";
import {StoreContext} from "../../../store.context";
import {TranslationDomainEnum} from "../../../types/enums";
import {Helmet} from "react-helmet-async";

const { Column } = Table;

export const ViewHistory: React.FC = observer(() => {
    const { token } = theme.useToken();
    const { id } : { id: any } = useParams() as any;

    const { appStore: { translate } } = useContext(StoreContext);
    const translationDomain = TranslationDomainEnum.COMPANY_ADMINISTRATION;
    const title = translate('servicer.title.servicers', {}, translationDomain);

    const navigate = useNavigate();
    const { data } : AgencyViewHistoryResponse = useLoaderData() as AgencyViewHistoryResponse;

    return (
            <>
                <Helmet>
                    <title>{`CL BO - ${title}`}</title>
                </Helmet>
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            { data.map((changeLogItem, index) => {
                return (
                    <ViewCardStyled key={index} title={
                        <>
                            <span>at { changeLogItem.loggedAt }</span>
                            <span> by { changeLogItem.username }</span>
                        </>
                    } style={{
                        background: token.colorBgContainer,
                    }}>
                        <React.Fragment>
                            <Table pagination={false} dataSource={changeLogItem.fieldChanges.map((field, key) => {
                                return {
                                    key,
                                    label: field.fieldAlias,
                                    translationDomain: field.translationDomain,
                                    newValue: field.new.map((n) => {
                                        return n.value
                                    }).join(', '),
                                    newName: field.new.map((n) => {
                                        return <><Translate message={n.name as string} domain={ n.translationDomain } />, </>
                                    }),
                                    newTranslationDomain: field.new[0]?.translationDomain ?? null,
                                    previousValue: field.previous.map((n) => {
                                        return n.value
                                    }).join(', '),
                                    previousName: field.previous.map((n) => {
                                        return <><Translate message={n.name as string} domain={ n.translationDomain } />, </>
                                    }),
                                    previousTranslationDomain: field.previous[0]?.translationDomain ?? null,
                                }
                            })}>
                                <Column<any> width={`33%`} title="Label" dataIndex="label" key="label" render={(_, record) => {
                                    return <Translate message={_} domain={ record.translationDomain } />
                                }} />
                                <Column<any> width={`33%`} title="Old value" dataIndex="previousValue" key="previousValue" render={(_, record) => {
                                    if (typeof record.previousValue === "boolean") {
                                        return <Translate message={record.previousValue ? `global.yes` : 'global.no'} />
                                    }

                                    if (record.previousTranslationDomain) {
                                        return record.previousName;
                                    } else {
                                        return record.previousValue;
                                    }
                                }}  />
                                <Column<any> width={`33%`} title="New value" dataIndex="newValue" key="newValue" render={(_, record) => {
                                    if (typeof record.newValue === "boolean") {
                                        return <Translate message={record.newValue ? `global.yes` : 'global.no'} />
                                    }

                                    if (record.newTranslationDomain) {
                                        return <Translate message={record.newName} domain={ record.newTranslationDomain } />;
                                    } else {
                                        return record.newValue;
                                    }
                                }}  />
                            </Table>
                        </React.Fragment>
                    </ViewCardStyled>
                )
            }) }

            <ButtonBar>
                <AccessUtil access={{ routeName: 'agency_edit', attributes: [{ id }]}}>
                    <Space>
                        <Button type={`primary`} onClick={ () => navigate(`/agency/${id}/edit`) }>
                            <Translate message={`global.button.edit`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <AccessUtil access={{ routeName: 'agency_view', attributes: [{ id }]}}>
                    <Space>
                        <Button type={`default`} onClick={ () => navigate(`/agency/${id}/view`) }>
                            <Translate message={`global.button.view`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/agency`) }>
                    <Translate message={`global.button.back_to_list`} />
                </Button>
            </ButtonBar>
        </Space>
            </>
    )
})